var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-fields-info-text-container" }, [
    _c("p", { staticClass: "instructions" }, [
      _vm._v(" " + _vm._s(_setup.text.instructions) + " "),
    ]),
    _setup.props.showInfoText
      ? _c(
          "div",
          { staticClass: "info-text-container" },
          [
            _c("span", {
              class: [_setup.icon.info, "lf-icon__md", "info-icon"],
            }),
            _c("p", { staticClass: "info-text" }, [
              _vm._v(" " + _vm._s(_setup.text.infoText) + " "),
            ]),
            _c("v-spacer"),
            _c("span", {
              class: [_setup.icon.close, "lf-icon__sm", "close-icon"],
              on: { click: _setup.closeInfoText },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }